import Vue from 'vue'
import Toast from 'vue-toasted'
import axios from 'axios'


const toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
}

Vue.use(Toast, toastOptions)
export default {
  //* CONSULTA DE ALUNOS
  async consultarHoraAtual () {

    try {
      let dataAtual = await axios.get('https://worldtimeapi.org/api/timezone/America/Fortaleza', {
        timeout: 3000
      })
      return dataAtual.data.datetime.replace(/T/g, ' ').split('.')[0]

    } catch (error) {
        var currentToday = new Date();
        var day = String(currentToday.getDate()).padStart(2, '0');
        var month = String(currentToday.getMonth() + 1).padStart(2, '0'); //Janeiro    0!
        var year = currentToday.getFullYear();
        var hour = String(currentToday.getHours()).padStart(2, '0');
        var minute = String(currentToday.getMinutes()).padStart(2, '0');
        var second = String(currentToday.getSeconds()).padStart(2, '0');

        return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second

    }
  },

  //* ALERT TOAST
  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    })
  },

}
